import { useContext } from 'react';
import { appContext } from '../appcontext';

export const useAppContext = () => useContext(appContext);
